import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PhoneBillDetailsModal = ({ show, onHide, bill }) => {
  if (!bill) return null;

  const hasDescription = Boolean(bill.description?.trim());
  const hasNotes = Boolean(bill.notes?.trim());

  return (
    <Modal show={show} onHide={onHide} centered className="phone-bill-details-modal">
      <Modal.Header closeButton>
        <Modal.Title>{bill.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!hasDescription && !hasNotes ? (
          <p className="text-muted mb-0">No description or notes for this bill.</p>
        ) : (
          <>
            {hasDescription && (
              <div className="phone-bill-details-block">
                <div className="phone-bill-details-label">Description</div>
                <div className="phone-bill-details-text">{bill.description}</div>
              </div>
            )}
            {hasNotes && (
              <div className="phone-bill-details-block">
                <div className="phone-bill-details-label">Notes</div>
                <div className="phone-bill-details-text">{bill.notes}</div>
              </div>
            )}
          </>
        )}
        {(hasDescription || hasNotes) && (
          <p className="phone-bill-details-hint">Tap and hold text to select and copy.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PhoneBillDetailsModal;
